module.exports = __webpack_public_path__ + "dc42dbd568686314c279b96b90121887.fbx";